import * as React from 'react';
import {Container, Sprite} from '@inlet/react-pixi';
import {Rectangle} from '@gongxigames/framework/core/fragments/react';
import {Texture} from 'pixi.js';

export type MatrixSymbolProps = {
    image: Texture;
    id: number;
    reel: number;
    row: number;
    onClick: (id: number, reel: number, row: number) => void;
    onRightClick: (id: number, reel: number, row: number) => void;
    selected?: boolean;
};

export class ReelsMatrixSymbol extends React.Component<MatrixSymbolProps> {
    protected onPointerTap(): void {
        const {id, reel, row} = this.props;

        this.props.onClick(id, reel, row);
    }

    protected onRightDown(): void {
        const {id, reel, row} = this.props;

        this.props.onRightClick(id, reel, row);
    }

    public render(): JSX.Element {
        const boxSize = 300;
        const {image, selected} = this.props;
        const size = Math.max(image.width, image.height);
        const scale = size > boxSize ? boxSize / size : 1;
        const rectColor = selected ? 0x004953 : 0x808898;

        return (
            <Container interactive={true} buttonMode={true} pointertap={this.onPointerTap.bind(this)} rightdown={this.onRightDown.bind(this)}>
                <Rectangle width={boxSize} height={boxSize} fill={rectColor} round={8}/>
                <Sprite x={boxSize / 2} y={boxSize / 2} anchor={0.5} scale={scale} texture={image}/>
            </Container>
        );
    }
}
